export var getInitials = function(name) {
    var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (name) {
        var initialList = name.trim().split(' ').map(function(i) {
            var j = i.trim().replace(/[^\w\s]/gi, '');
            return j ? j[0] : '';
        }).filter(function(i) {
            return !!i;
        });
        if (initialList.length) {
            return initialList.slice(0, count).join('').toUpperCase();
        }
    }
    return '';
};
export var colorPallete = [
    '001791',
    '003A56',
    '006391',
    '00845C',
    '008ACA',
    '026446',
    '112E51',
    '1E4620',
    '2B1E46',
    '2D5D6C',
    '301863',
    '357B38',
    '3D4B92',
    '461E1E',
    '461E42',
    '4B3778',
    '4F5E15',
    '560000',
    '622443',
    '625124',
    '63308A',
    '6A3F17',
    '731C36',
    '865DA6',
    '8A3232',
    '8A325F',
    'A95B12',
    'AA517E',
    'AE0000',
    'B92D2D'
];
export var getRandomColor = function() {
    var colors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : colorPallete;
    var randomNumber = Math.floor(Math.random() * colors.length);
    return colors[randomNumber];
};
export var stringToColor = function(string) {
    var hash = 0;
    var i;
    /* eslint-disable no-bitwise */ for(i = 0; i < string.length; i += 1){
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = '#';
    for(i = 0; i < 3; i += 1){
        var value = hash >> i * 8 & 0xff;
        color += "00".concat(value.toString(16)).slice(-2);
    }
    /* eslint-enable no-bitwise */ return color;
};
export var stringAvatar = function(name, email) {
    return {
        sx: {
            width: 24,
            height: 24,
            fontSize: 12,
            bgcolor: stringToColor(name),
            textTransform: 'uppercase'
        },
        children: name.trim() ? getInitials(name) : email[0]
    };
};
